module.exports = __webpack_public_path__ + "img/홍대 맛집.f9fd2312.png";